module.exports = __webpack_public_path__ + "img/kw.c58f2a93.svg";